import React from 'react';
import ImportFileModal from './ImportFileModal';
import { ImportSource } from '../../graphql/generated/graphql';
import Link from '../../utils/router/Link';

interface ConfluenceImportModalProps {
  close: () => void;
}

const ConfluenceImportModal = ({ close }: ConfluenceImportModalProps) => (
  <ImportFileModal
    close={close}
    source={ImportSource.Confluence}
    uploaderSubject="Confluence backup zip file"
    footer={
      <>
        Upload your{' '}
        <Link to="https://go.slab.com/importing-from-confluence" newTab>
          Confluence backup file
        </Link>{' '}
        to import into Slab.
      </>
    }
    forceBucketUpload
  />
);

export default ConfluenceImportModal;
